import React from 'react';
import { Col, Row } from 'react-bootstrap';

function IconGrid({ items, columns = { xs: 4, md: 2 } }) {
  return (
    <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
      {items.map((item, index) => {
        const IconComponent = item.icon;
        return (
          <Col key={index} xs={columns.xs} md={columns.md} className="tech-icons">
            <IconComponent />
            <p style={{ fontSize: 15 }}>{item.label}</p>
          </Col>
        );
      })}
    </Row>
  );
}

export default IconGrid;